import React from "react"
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import LogoTitle from '../../assets/images/logo-s.png';
import AnimatedLetters from "../AnimatedLetters";
import Loader from "react-loaders"
import './index.scss';

const Home = () => {

    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            return setLetterClass('text-animate-hover')
        }, 4000)
    }, [])

    return (
        <>
        <div className="container home-page">
            <div className="text-zone">
                <h1>
                    <span className={letterClass}>H</span>
                    <span className={`${letterClass} _12`}>i,</span>
                <br />
                    <span className={`${letterClass} _13`}>I</span>
                    <span className={`${letterClass} _14`}>&nbsp;am</span>
                <img src={LogoTitle} alt='developer' />
                    <AnimatedLetters letterClass={letterClass}
                    strArray={"nton,".split("")}
                    idx={15} />
                <br />
                    <AnimatedLetters letterClass={letterClass}
                    strArray={"a web developer".split("")}
                    idx={21} />
                </h1>
                <h2>Full-Stack Developer</h2>
                <Link to="/contact" className='flat-button'>
                    CONTACT ME!
                </Link>
            </div>
        </div>
        <Loader type="semi-circle-spin" />
        </>
    )
}

export default Home
